export default "__VITE_ASSET__27f481d2__"